import React from 'react';

import classNames from 'classnames';

import Svg from '@/components/Svg';

import styles from './NotificationError.module.scss';

type NotificationErrorProps = {
  mainText: string;
  subText: string | string[];
  icon: boolean;
  className?: string;
  id?: string;
};

const NotificationError = ({ mainText, subText, icon, className, id }: NotificationErrorProps) => {
  const classes = classNames([styles.notification], {
    [styles['-icon']]: !!icon,
    [className as string]: !!className,
  });

  const handleSubText = (messages: string | string[]) => {
    if (Array.isArray(messages)) {
      // eslint-disable-next-line react/no-array-index-key,react/jsx-key
      return messages?.map((message) => <p className={styles.msg}>{message}</p>);
    }

    return <p className={styles.msg}>{subText}</p>;
  };

  return (
    <div className={classes} id={id}>
      <div className={styles['notification-content']}>
        {icon && (
          <div className={styles['notification-icon']}>
            <Svg glyph="alert" ariaLabel="alert" iconId="alert" fill="#fff" width={24} height={24} />
          </div>
        )}
        <div className={styles['notification-main']} role="alert" aria-live="polite">
          <p className={styles.title}>
            <strong>{mainText}</strong>
          </p>
          {handleSubText(subText)}
        </div>
      </div>
    </div>
  );
};

export default NotificationError;
